import React from 'react';
import { KeenIcon } from '@/components';

const AgentChatPreview = ({ introduction, greeting, fill = '#FFFFFF', stroke = '#FFFFFF' }) => (
  <div className="flex-1 bg-white p-4 h-[550px] flex flex-col">
    <div className="flex-1 overflow-y-auto pr-2">
      <div className="mb-4">
        <div className="border rounded-lg p-5 mb-2 min-h-0" style={{ borderColor: stroke, backgroundColor: fill, borderWidth: '2px' }}>
          <div className="whitespace-pre-wrap break-words text-xl">{introduction}</div>
        </div>
        <div className="border rounded-lg p-3 mb-2 min-h-0" style={{ borderColor: stroke, backgroundColor: fill }}>
          <div className="whitespace-pre-wrap break-words text-sm">{greeting}</div>
        </div>
      </div>
    </div>
    <div className="flex flex-col gap-2 mt-4 pt-4 border-t">
      <span className="inline-flex items-center px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs w-fit">
        <span className="mr-1"><KeenIcon icon="star" /></span> Thời gian làm việc của Bệnh viện
      </span>
      <div className="flex items-center gap-2">
        <input
          className="flex-1 border rounded px-3 py-2 text-sm"
          placeholder="Nhập tin nhắn..."
          maxLength={500}
        />
        <button className="bg-[#00B14F] text-white px-4 py-2 rounded text-sm flex items-center gap-1">
          GỬI <KeenIcon icon="double-check" />
        </button>
      </div>
    </div>
  </div>
);

export { AgentChatPreview };